export const messages = {
  title: 'Your business account is ready!',
  subtitle: (newAccountName = '') =>
    `Your team can now start booking trips on ${newAccountName}`,
  take: (newAccountName) => `Take me to ${newAccountName}`,
  stay: (currentAccountName = '') => `Stay on ${currentAccountName}`,
};
